import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReasonModel } from '../model/reason.model';
import { ReasonService } from '../reason.service';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-reason-edit',
  templateUrl: './reason-edit.component.html',
  styleUrls: ['./reason-edit.component.scss'],
  standalone: false
})
export class ReasonEditComponent implements DirtyCheck {
  title: string = "New Reason";
  editForm!: FormGroup;
  reasonInfo: ReasonModel = {};
  isFormDirty: boolean = false;
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private reasonService: ReasonService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService
  ) {
    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      description: [this.reasonInfo.description, [Validators.required]],
      display_order: [this.reasonInfo.display_order !== undefined ? this.reasonInfo.display_order : 0, [Validators.required, Validators.min(0)]]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (id !== null && parseInt(id) !== 0) {
      this.setReasonInfo(id);
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("reason"), id);
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/system/reason']);
  }

  setReasonInfo(id: any): void {
    this.reasonService.getReasonById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.reasonInfo = response.data.reason;
          this.editForm.patchValue({
            description: this.reasonInfo.description,
            display_order: this.reasonInfo.display_order ?? 0
          });
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      }
    });
  }

  getTitle(): string {
    return (!this.reasonInfo.id || this.reasonInfo.id == 0) ? "New Reason" : "Editing : " + (this.reasonInfo.description || '');
  }

  save(): void {
    if (this.editForm.valid) {
      Object.assign(this.reasonInfo, this.editForm.value);
      this.reasonInfo.context = 1;

      this.reasonService.update(this.reasonInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Saved',
              message: `Reason has been saved successfully.`
            });
            this.router.navigate(['/system/reason']);
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        },
        error: (error) => {
          this.snackBarService.openSnackBar({ message: 'Connection to the server failed', title: 'Failed!!!', type: 'error' });
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
